import { useTranslation } from "react-i18next";

import { MainLayout } from "components/layouts";
import LeaveTypeForm from "./LeaveTypeForm";

import styles from "../styles/LeaveType.module.css";
import { Breadcrumb, Flex, Space } from "antd";
import { useNavigate } from "react-router-dom";

function LeaveTypeCreate(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "/configuration/attendance" },
            { title: t("attendance_setting.header"), href: "/configuration/attendance" },
            {
              title: t("leave_type.header"),
              href: "/configuration/attendance",
              onClick: (e) => {
                e.preventDefault();
                navigate("/configuration/attendance", { state: { selectedTab: 'leave' } });
              }
            },
            { title: t("common.create") },
          ]} />
          <h2>{t("common.create")}</h2>
        </Flex>
        <LeaveTypeForm {...props} />
      </Space>
    </MainLayout>
  );
}

export default LeaveTypeCreate;
